<template>
  <div>
    <ElacTenantsListItem
      v-for="tenant in tenants"
      :key="tenant.id"
      :tenant="tenant"
      @click="$emit('select', tenant)"
    />

    <ElacSharedLoader v-model="loading" />
    <ElacSharedEmptyList
      :value="!loading && !tenants.length"
      text="Aucun projet trouvé"
    />
  </div>
</template>

<script>
import ElacSharedLoader from '@/components/shared/ElacSharedLoader.vue';
import ElacSharedEmptyList from '@/components/shared/ElacSharedEmptyList.vue';
import ElacTenantsListItem from '@/components/tenants-list/ElacTenantsListItem.vue';

export default {
  name: 'ElacTenantsList',
  components: { ElacSharedLoader, ElacTenantsListItem, ElacSharedEmptyList },

  data: () => ({
    loading: false,
  }),

  computed: {
    tenants() {
      return this.$store.getters['tenants/tenants'];
    },
  },

  mounted() {
    this.loading = true;

    return this.$store.dispatch('tenants/getTenants', { refresh: true })
      .catch(err => this.$err(err))
      .finally(() => (this.loading = false));
  },
};
</script>
